// @flow
/* eslint-disable react/no-did-mount-set-state */
/* eslint-disable react/no-did-update-set-state */
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Error } from '../../core';
import {
  getFileTypes,
  getFilesByType,
  downloadFile,
} from '../redux/csvActions';

import type { FilesByTypeDefinition, FileTypeDefinition } from '../type';
import type { ApiError } from '../../core/type/index';

type Props = {
  getFileTypes: () => Promise<*>,
  getFilesByType: (string | void) => Promise<*>,
};

type State = {
  currentFileType?: string,
  errorStatus?: number,
  filesByType?: FilesByTypeDefinition,
  filesByTypeError?: ApiError,
  fileTypes?: FileTypeDefinition[],
  fileTypesError?: ApiError,
  loadingFileTypes: boolean,
  loadingFilesByType: boolean,
};

class Csvs extends React.Component<Props, State> {
  state = {
    currentFileType: undefined,
    errorStatus: undefined,
    filesByType: undefined,
    filesByTypeError: undefined,
    fileTypes: undefined,
    fileTypesError: undefined,
    loadingFileTypes: false,
    loadingFilesByType: false,
  };

  async componentDidMount() {
    this.setState({ loadingFileTypes: true });

    const data = await this.props.getFileTypes();

    if (data && data.payload && data.response.ok) {
      this.setState({
        fileTypes: data.payload,
        currentFileType: data.payload[0].Key,
        loadingFileTypes: false,
      });
    } else {
      this.setState({
        fileTypesError: data.payload,
        errorStatus: data.response.status,
        loadingFileTypes: false,
      });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.currentFileType !== this.state.currentFileType) {
      if (this.state.currentFileType) {
        this.setState({ loadingFilesByType: true });

        const data = await this.props.getFilesByType(
          this.state.currentFileType
        );

        if (data && data.payload && data.response.ok) {
          this.setState({
            filesByTypeError: undefined,
            filesByType: data.payload,
            loadingFilesByType: false,
          });
        } else {
          this.setState({
            filesByTypeError: data.payload,
            errorStatus: data.response.status,
            loadingFilesByType: false,
          });
        }
      }
    }
  }

  render() {
    const {
      errorStatus,
      fileTypes,
      fileTypesError,
      filesByType,
      filesByTypeError,
      loadingFilesByType,
      loadingFileTypes,
    } = this.state;

    const currentFileType =
      this.state.currentFileType || (fileTypes && fileTypes[0].Key);

    if (fileTypesError) {
      return <Error error={fileTypesError} errorStatus={errorStatus} />;
    }

    if (loadingFileTypes) {
      return <div className="loader" />;
    }

    return (
      <>
        <ul className="nav-tabs">
          {fileTypes &&
            fileTypes.map(type => (
              <li key={type.Key}>
                <button
                  href=""
                  className={currentFileType === type.Key ? 'active' : ''}
                  onClick={e => this.onTabChange(e, type.Key)}
                >
                  {type.Name}
                </button>
              </li>
            ))}
        </ul>
        {loadingFilesByType && <div className="loader" />}
        {!loadingFilesByType && filesByTypeError && (
          <Error error={filesByTypeError} errorStatus={errorStatus} />
        )}
        {!loadingFilesByType && !filesByTypeError && (
          <table className="csv-table">
            <thead>
              <tr>
                <th>File Name</th>
                <th>Created On</th>
              </tr>
            </thead>
            <tbody>
              {filesByType &&
                filesByType.Data.map(data =>
                  data.Contents.map(file => (
                    <tr key={file.Uri}>
                      <td>{file.Filename}</td>
                      <td>{moment(data.CreationDate).format('DD/MM/YYYY')}</td>
                      <td className="csv-download--btn">
                        <Button
                          text="Download"
                          small
                          value={file.Uri}
                          onClick={e => this.downloadFile(e, file.Uri)}
                        />
                      </td>
                    </tr>
                  ))
                )}
            </tbody>
          </table>
        )}
      </>
    );
  }

  onTabChange = (e: Event, name: string) => {
    e.preventDefault();
    this.setState({
      currentFileType: name,
    });
  };

  downloadFile = (e: Event, uri: string) => {
    const { currentFileType } = this.state;

    if (currentFileType) {
      downloadFile(currentFileType, uri);
    }
  };
}

const mapDispatchToProps = dispatch => ({
  getFileTypes: bindActionCreators(getFileTypes, dispatch),
  getFilesByType: bindActionCreators(getFilesByType, dispatch),
});

export default connect(null, mapDispatchToProps)(Csvs);
